import React from "react";
import Table from "./Table";
import PropTypes from 'prop-types'

const Tables = ({ data, isValue }) => {
	return(	
		<div className="flex flex-row mt-5">
			{
				data.map((valueGroup, idx) => (
					<Table key={idx} 
						title={valueGroup.name} 
						data={ valueGroup.children }
						isValue={isValue}
					/>
				))
			}
		</div>
	)
}

Tables.propTypes = {
	titleList: PropTypes.array,
	dataList: PropTypes.array,
}

export default Tables